import React from 'react';
import PropTypes from 'prop-types';
import VideoPlayerComponent from '../video/videoPlayerComponent';
import './templates.css';

export default function EditorialTemplate(props) {
  return (
    <div className="tpx-editorial-tmp">
      <VideoPlayerComponent {...props} />
    </div>
  );
}

EditorialTemplate.propTypes = {
  config: PropTypes.object.isRequired,
  videoPlayer: PropTypes.object.isRequired,
  playlistmodel: PropTypes.object.isRequired,
};
